'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export type TagVariant = 'default' | 'accent';

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: TagVariant;
  count?: number;
}

const VARIANT: Record<TagVariant, string> = {
  default: 'bg-surface-3 text-text-secondary border border-border-subtle',
  accent: 'bg-accent-soft text-accent',
};

export const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  ({ variant = 'default', count, className, children, ...rest }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'rounded-sm h-[22px] px-2 text-[11px] font-medium inline-flex items-center gap-1.5',
          VARIANT[variant],
          className
        )}
        {...rest}
      >
        {children}
        {count !== undefined && (
          <span className="opacity-70 tabular-nums">{count}</span>
        )}
      </span>
    );
  }
);
Tag.displayName = 'DsTag';
